import React from 'react';
import VideoBanner from './components/VideoBanner';
import emailjs from "@emailjs/browser";

emailjs.init('ouoJHHjrIyOMq6bTk');

// Navigation Bar Component
const NavBar = () => {
  return (
    <nav style={{
      /* backgroundColor: 'rgba(0, 0, 0, 0.3)', */
      backgroundColor: '#150811',
      backdropFilter: 'blur(20px)',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '0 40px',
        height: '60px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          fontWeight: 600,
          color: '#fff',
          fontSize: '24px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <img
            src='/resources/SQINBOX-logo-hor.png'
            alt='SQINBOX'
            width={130}
          />
        </div>
        {/* <div style={{ display: 'flex', gap: '40px', alignItems: 'center' }}>
          {['Movies', 'TV Series', "Editor's Pick", 'Interviews', 'User Reviews'].map(item => (
            <a key={item} href="#" style={{
              color: '#fff',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: 400,
              transition: 'opacity 0.3s',
              opacity: 0.9,
              borderBottom: item === "Editor's Pick" ? '2px solid #fff' : 'none',
              paddingBottom: item === "Editor's Pick" ? '4px' : '0'
            }}
              onMouseOver={(e) => e.target.style.opacity = 1}
              onMouseOut={(e) => e.target.style.opacity = 0.9}
            >
              {item}
            </a>
          ))}
          <button style={{
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            color: '#fff',
            padding: '8px 20px',
            borderRadius: '20px',
            fontSize: '14px',
            cursor: 'pointer',
            backdropFilter: 'blur(10px)'
          }}>
            Search 🔍
          </button>
          <button style={{
            backgroundColor: 'transparent',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            color: '#fff',
            padding: '8px',
            borderRadius: '50%',
            fontSize: '16px',
            cursor: 'pointer',
            width: '36px',
            height: '36px'
          }}>
            👤
          </button>
        </div> */}
      </div>
    </nav>
  );
};

// Video Modal Component
const VideoModal = ({ isOpen, onClose, videoSrc }) => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        backdropFilter: 'blur(20px)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: isMobile ? '0' : '20px',
        animation: 'fadeIn 0.3s ease-out'
      }}
    >
      <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                @keyframes scaleIn {
                    from { transform: scale(0.9); opacity: 0; }
                    to { transform: scale(1); opacity: 1; }
                }
            `}</style>

      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: isMobile ? '100%' : '75%',
          maxWidth: isMobile ? '100%' : '1400px',
          position: 'relative',
          animation: 'scaleIn 0.3s ease-out'
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: isMobile ? '10px' : '-50px',
            right: isMobile ? '10px' : '0',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            backdropFilter: 'blur(10px)',
            border: 'none',
            color: '#fff',
            fontSize: '24px',
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s',
            zIndex: 10
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.3)';
            e.target.style.transform = 'scale(1.1)';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
            e.target.style.transform = 'scale(1)';
          }}
        >
          ×
        </button>

        <video
          style={{
            width: '100%',
            height: 'auto',
            borderRadius: isMobile ? '0' : '16px',
            boxShadow: '0 30px 60px rgba(0, 0, 0, 0.5)'
          }}
          controls
          autoPlay
          loop
          playsInline
        >
          <source src={videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

// Cinematic Hero Section
const CinematicHero = ({ backgroundImage, videoSrc, thumbnailImage }) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <section style={{
        position: 'relative',
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'flex-end'
      }}>
        {/* Background Image */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: 0
        }} />

        {/* Gradient Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.7) 100%)',
          zIndex: 1
        }} />

        {/* Content Container */}
        <div style={{
          position: 'relative',
          zIndex: 2,
          width: '100%',
          padding: isMobile ? '40px 20px 60px' : '60px 60px 100px',
          maxWidth: '1400px',
          margin: '0 auto'
        }}>
          {/* Video Thumbnail & Info Row */}
          <div style={{
            display: 'flex',
            gap: isMobile ? '20px' : '30px',
            alignItems: 'flex-start',
            marginBottom: '30px',
            flexWrap: isMobile ? 'wrap' : 'nowrap'
          }}>
            {/* Video Thumbnail with Image */}
            <div
              onClick={() => setIsModalOpen(true)}
              style={{
                position: 'relative',
                height: isMobile ? '120px' : '200px',
                width: isMobile ? '160px' : '280px',
                borderRadius: '12px',
                overflow: 'hidden',
                cursor: 'pointer',
                flexShrink: 0,
                border: '2px solid rgba(255, 255, 255, 0.3)',
                transition: 'transform 0.3s, border-color 0.3s',
                backgroundColor: '#1a1a1a'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.6)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
              }}
            >
              {/* Thumbnail Image */}
              {thumbnailImage ? (
                <img
                  src={thumbnailImage}
                  alt="Video thumbnail"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                    display: 'block'
                  }}
                />
              ) : (
                <div style={{
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)'
                }} />
              )}

              {/* Play Button Overlay */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                transition: 'background-color 0.3s'
              }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.5)'}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.3)'}
              >
                <div style={{
                  width: isMobile ? '40px' : '60px',
                  height: isMobile ? '40px' : '60px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255, 255, 255, 0.95)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: isMobile ? '18px' : '28px',
                  paddingLeft: '4px',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.4)',
                  transition: 'transform 0.3s'
                }}
                  onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                  onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                >
                  ▶
                </div>
              </div>
            </div>

            {/* Movie Info */}
            {/* <div style={{ display: 'flex', gap: isMobile ? '15px' : '25px', alignItems: 'center', flexWrap: 'wrap' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ color: '#ffd700', fontSize: isMobile ? '18px' : '20px' }}>⭐</span>
                <span style={{ color: '#fff', fontSize: isMobile ? '16px' : '18px', fontWeight: 500 }}>8.7/10 IMDB</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ color: '#fff', fontSize: isMobile ? '18px' : '20px' }}>🕐</span>
                <span style={{ color: '#fff', fontSize: isMobile ? '16px' : '18px' }}>132 min</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ color: '#fff', fontSize: isMobile ? '18px' : '20px' }}>📅</span>
                <span style={{ color: '#fff', fontSize: isMobile ? '16px' : '18px' }}>April, 2025</span>
              </div>
            </div> */}
          </div>

          {/* Title & Description */}
          <h1 style={{
            fontSize: isMobile ? '42px' : '72px',
            fontWeight: 600,
            color: '#fff',
            margin: '0 0 20px 0',
            lineHeight: 1.1,
            textShadow: '0 2px 10px rgba(0,0,0,0.5)'
          }}>
            The world's first AI-driven immersive skincare pod
          </h1>

          <p style={{
            fontSize: isMobile ? '18px' : '24px',
            color: 'rgba(255, 255, 255, 0.9)',
            margin: '0 0 40px 0',
            maxWidth: '700px',
            lineHeight: 1.5,
            textShadow: '0 1px 5px rgba(0,0,0,0.5)'
          }}>
            Enter → Renew → Glow Your Soul
          </p>

          {/* Action Buttons */}
          <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
            <button
              onClick={() => setIsModalOpen(true)}
              style={{
                padding: isMobile ? '14px 30px' : '16px 40px',
                fontSize: isMobile ? '16px' : '18px',
                fontWeight: 500,
                backgroundColor: '#fff',
                color: '#000',
                border: 'none',
                borderRadius: '30px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                transition: 'all 0.3s',
                boxShadow: '0 4px 15px rgba(0,0,0,0.3)'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'scale(1.05)';
                /* e.target.style.boxShadow = '0 6px 20px rgba(0,0,0,0.4)'; */
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'scale(1)';
                /* e.target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.3)'; */
              }}
            >
              <span style={{ fontSize: '20px', backgroundColor: "none" }}>▶</span> Watch Trailer
            </button>

            {/* <button style={{
              padding: isMobile ? '14px 30px' : '16px 40px',
              fontSize: isMobile ? '16px' : '18px',
              fontWeight: 500,
              backgroundColor: 'rgba(255, 255, 255, 0.15)',
              color: '#fff',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              borderRadius: '30px',
              cursor: 'pointer',
              backdropFilter: 'blur(10px)',
              transition: 'all 0.3s'
            }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.25)';
                e.target.style.transform = 'scale(1.05)';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.15)';
                e.target.style.transform = 'scale(1)';
              }}
            >
              Show More
            </button> */}
          </div>
        </div>

        {/* Navigation Arrows */}
        {/* <div style={{
          position: 'absolute',
          bottom: isMobile ? '20px' : '60px',
          right: isMobile ? '20px' : '60px',
          display: 'flex',
          gap: '15px',
          zIndex: 2
        }}>
          <button style={{
            padding: '12px 24px',
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '30px',
            color: '#fff',
            cursor: 'pointer',
            backdropFilter: 'blur(10px)',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            ← Previous
          </button>
          <button style={{
            padding: '12px 24px',
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '30px',
            color: '#fff',
            cursor: 'pointer',
            backdropFilter: 'blur(10px)',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            Next →
          </button>
        </div> */}
      </section>

      <VideoModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        videoSrc={videoSrc || "/resources/SQINBOX-AD-Intro-dec25-comp.mp4"}
      />
    </>
  );
};

const TwoUpGrid = ({ leftItem, rightItem }) => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const ImageCard = ({ image, alt }) => (
    <div style={{
      position: 'relative',
      overflow: 'hidden',
      minHeight: isMobile ? '400px' : '580px',
      backgroundColor: '#1a1a1a'
    }}>
      <img
        src={image}
        alt={alt || 'Product image'}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center',
          display: 'block'
        }}
      />
    </div>
  );

  const ContentCard = ({ title, subtitle, bgColor, textColor, description }) => (
    <div style={{
      backgroundColor: bgColor,
      color: textColor,
      padding: isMobile ? '40px 20px' : '56px 40px',
      textAlign: 'center',
      position: 'relative',
      overflow: 'hidden',
      minHeight: isMobile ? '400px' : '580px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <div style={{ position: 'relative', zIndex: 1, maxWidth: '500px' }}>
        <h2 style={{
          fontSize: isMobile ? '40px' : '48px',
          fontWeight: 600,
          margin: '0 0 8px 0',
          lineHeight: 1.1
        }}>
          {title}
        </h2>
        <p style={{
          fontSize: isMobile ? '21px' : '24px',
          margin: '0 0 16px 0',
          opacity: 0.9
        }}>
          {subtitle}
        </p>
        {description && (
          <p style={{
            fontSize: isMobile ? '17px' : '19px',
            margin: '0 0 24px 0',
            opacity: 0.8,
            lineHeight: 1.5
          }}>
            {description}
          </p>
        )}
      </div>
    </div>
  );

  const renderCard = (item) => {
    if (item.type === 'image') {
      return <ImageCard image={item.image} alt={item.alt} />;
    } else {
      return <ContentCard {...item} />;
    }
  };

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
      gap: '12px',
      padding: '12px',
      maxWidth: '100%'
    }}>
      {renderCard(leftItem)}
      {renderCard(rightItem)}
    </div>
  );
};

const WaitingListBar = ({ title = "Join the waiting list", subtitle = "Be the first to know when we launch" }) => {
  const [email, setEmail] = React.useState('');
  const [error, setError] = React.useState("");
  const [success, setSuccess] = React.useState(false);
  const [/* status,  */setStatus] = React.useState(''); // 'success', 'error', or ''

  // Simple email regex validation
  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic email validation
    if (!email || !email.includes('@')) {
      setStatus('error');
      return;
    }

    if (!validateEmail(email)) {
      setError("Please enter a valid email.");
      setSuccess(false);
      return;
    }
    setError("");

    try {
      const responseReq = await sendReqWaitingListEmail(email);

      if (responseReq !== null) {
        setSuccess(true);
        setEmail(""); // Clear email field
      }
    } catch (error) {
      setError("Unable to send your comment. Please try again later.");
    }

    // Reset status after 3 seconds
    setTimeout(() => setSuccess(''), 7000);
    setTimeout(() => setError(''), 7000);
  };

  return (
    <section style={{
      backgroundColor: '#FFD7E9',
      padding: '60px 20px',
      textAlign: 'center'
    }}>
      <div style={{
        maxWidth: '600px',
        margin: '0 auto'
      }}>
        <h2 style={{
          fontSize: '40px',
          fontWeight: 600,
          margin: '0 0 8px 0',
          color: '#1d1d1f'
        }}>
          {title}
        </h2>
        <p style={{
          fontSize: '21px',
          color: '#86868b',
          margin: '0 0 32px 0'
        }}>
          {subtitle}
        </p>

        <div style={{
          display: 'flex',
          gap: '12px',
          maxWidth: '500px',
          margin: '0 auto',
          flexWrap: 'wrap',
          justifyContent: 'center'
        }}>
          <input
            id="email"
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              flex: '1',
              minWidth: '250px',
              padding: '16px 20px',
              fontSize: '17px',
              border: '1px solid #d2d2d7',
              borderRadius: '12px',
              outline: 'none',
              backgroundColor: '#fff',
              transition: 'border-color 0.2s'
            }}
            onFocus={(e) => e.target.style.borderColor = '#100C0B'}
            onBlur={(e) => e.target.style.borderColor = '#d2d2d7'}
          />
          <button
            onClick={handleSubmit}
            style={{
              padding: '16px 32px',
              fontSize: '17px',
              fontWeight: 400,
              backgroundColor: '#100C0B',
              color: '#fff',
              border: 'none',
              borderRadius: '12px',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
              whiteSpace: 'nowrap'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#1C1B17'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#100C0B'}
          >
            Join Waitlist
          </button>
        </div>

        {/* {status === 'success' && (
          <p style={{
            marginTop: '16px',
            color: '#34c759',
            fontSize: '17px',
            fontWeight: 500
          }}>
            ✓ Thanks! You're on the list. We will circle back to you soon!
          </p>
        )} */}

        {error && (
          <p className="mt-2 text-red-500 text-sm font-medium">{error}</p>
        )}
        {success && (
          <p style={{
            marginTop: '16px',
            color: 'green',
            fontSize: '17px',
            fontWeight: 500
          }}>
            ✓ Thanks! You're on the list. We will circle back to you soon!
          </p>
        )}

        {/* {status === 'error' && (
          <p style={{
            marginTop: '16px',
            color: '#ff3b30',
            fontSize: '17px',
            fontWeight: 500
          }}>
            Please enter a valid email address.
          </p>
        )} */}
      </div>
    </section>
  );
};

const HowItWorks = ({ title, subtitle, steps }) => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
  const [hoveredIndex, setHoveredIndex] = React.useState(null);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section style={{
      padding: isMobile ? '60px 20px' : '100px 40px',
      backgroundColor: '#000'
    }}>
      {/* Section Header */}
      <div style={{
        textAlign: 'center',
        marginBottom: isMobile ? '50px' : '80px',
        maxWidth: '800px',
        margin: `0 auto ${isMobile ? '50px' : '80px'} auto`,
        paddingBottom: isMobile ? '0' : '20px'
      }}>
        <h2 style={{
          fontSize: isMobile ? '40px' : '56px',
          fontWeight: 600,
          color: '#fff',
          margin: '0 0 16px 0'
        }}>
          {title}
        </h2>
        <p style={{
          fontSize: isMobile ? '19px' : '24px',
          color: 'rgba(255, 255, 255, 0.7)',
          margin: 0
        }}>
          {subtitle}
        </p>
      </div>

      {/* Steps Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
        gap: isMobile ? '24px' : '30px',
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        {steps.map((step, index) => (
          <div
            key={index}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            style={{
              position: 'relative',
              borderRadius: '20px',
              overflow: 'hidden',
              minHeight: isMobile ? '400px' : '500px',
              /* cursor: 'pointer', */
              transition: 'transform 0.3s, box-shadow 0.3s',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
              backgroundColor: '#1a1a1a',
              transform: hoveredIndex === index ? 'translateY(-10px)' : 'translateY(0)',
              border: '1px solid rgba(255, 255, 255, 0.1)'
            }}
          >
            {/* Background Image - Shows on Hover */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: `url(${step.backgroundImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              zIndex: 0,
              filter: hoveredIndex === index ? 'blur(0px)' : 'blur(10px)',
              transform: hoveredIndex === index ? 'scale(1.03)' : 'scale(1)',
              transition: 'all 0.6s ease-in-out'
            }} />

            {/* Gradient Overlay - Darker when not hovered */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: hoveredIndex === index
                ? 'linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.7) 100%)'
                : 'linear-gradient(to bottom, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.95) 100%)',
              zIndex: 1,
              transition: 'background 0.5s ease-in-out'
            }} />

            {/* Content */}
            <div style={{
              position: 'relative',
              zIndex: 2,
              padding: isMobile ? '30px' : '40px',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
              color: '#fff'
            }}>
              {/* Step Number */}
              <div style={{
                fontSize: isMobile ? '60px' : '80px',
                fontWeight: 700,
                lineHeight: 1,
                marginBottom: '20px',
                opacity: 0.3,
                fontFamily: 'Georgia, serif'
              }}>
                {step.number}
              </div>

              {/* Step Title */}
              <h3 style={{
                fontSize: isMobile ? '32px' : '40px',
                fontWeight: 600,
                margin: '0 0 16px 0',
                lineHeight: 1.2
              }}>
                {step.title}
              </h3>

              {/* Step Description */}
              <p style={{
                fontSize: isMobile ? '17px' : '19px',
                lineHeight: 1.6,
                margin: 0,
                opacity: 0.9
              }}>
                {step.description}
              </p>

            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

const Footer = () => {
  const [hover, setHover] = React.useState(false);
  return (
    <footer style={{
      backgroundColor: '#f5f5f7',
      padding: '40px 20px',
      marginTop: '60px'
    }}>
      <div style={{
        maxWidth: '980px',
        margin: '0 auto',
        textAlign: 'center'
      }}>
        {/* <div style={{
          display: 'flex',
          gap: '40px',
          justifyContent: 'center',
          marginBottom: '20px',
          flexWrap: 'wrap'
        }}>
          {['Privacy', 'Terms', 'Contact', 'About'].map(item => (
            <a key={item} href="#" style={{
              color: '#424245',
              textDecoration: 'none',
              fontSize: '12px'
            }}>
              {item}
            </a>
          ))}
        </div> */}
        <p style={{
          fontSize: '12px',
          color: '#86868b',
          margin: 0
        }}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          © 2026 Sqinbox Inc. All rights reserved . ✉ info@sqinbox.com . Connecting with <a href="https://linktr.ee/sqinbox" target="_blank" rel="noreferrer" id="sqinbox-link" style={{ color: hover ? '#a855f7' : 'inherit' }}>@sqinbox</a> everywhere! . [H] Miami, FL 33127
        </p>
      </div>
    </footer>
  );
};

// Main App
const App = () => {
  return (
    <div style={{ backgroundColor: '#000', minHeight: '100vh' }}>
      <NavBar />
      <CinematicHero
        backgroundImage="/resources/webp/SQINBOX-shot6-1-comp.webp"
        thumbnailImage="/resources/webp/SQINBOX-shot16-3-1920.webp"
        videoSrc="/resources/SQINBOX-AD-Intro-dec25-comp.mp4"
      />

      <WaitingListBar
        title="Know exactly what your skin needs — and treat it immediately."
        subtitle="SQINBOX analyzes your skin in real time and applies a personalized treatment in the same session.
No guessing. No trial products. No generic routines."
      />

      <TwoUpGrid
        leftItem={{
          type: 'image',
          image: '/resources/webp/pod-street-5.webp',
          alt: ''
        }}
        rightItem={{
          type: 'content',
          title: "Imagine a closed, private pod located in everyday places like malls and airports.",
          subtitle: "From the outside, it is minimal and self-contained. It doesn’t display products, prices, or menus.",
          description: "The exterior signals a single function: this is where skin analysis and treatment happen now.",  // Optional
          bgColor: "#F1F0EF",
          textColor: "#1d1d1f"
        }}
      />

      <TwoUpGrid
        leftItem={{
          type: 'content',
          title: "Inside the pod, the environment is fully controlled to allow accurate skin analysis.",
          subtitle: "Lighting is uniform and shadow-free. The space is private, quiet, and designed only for your skin. Everything serves analysis and treatment.",
          bgColor: "#000",
          textColor: "#fff"
        }}
        rightItem={{
          type: 'image',
          image: '/resources/webp/SQINBOX-shot11-2-comp.webp',
          alt: ''
        }}
      />

      <HowItWorks
        title="How It Works"
        subtitle="Three simple steps to Glow"
        steps={[
          {
            number: "01",
            title: "Scan",
            description: "Your face is scanned non-invasively to reveal real skin data.",
            backgroundImage: "/resources/webp/SQINBOX-shot13-4.webp"
          },
          {
            number: "02",
            title: "Understand",
            description: "You see what your skin needs and why previous routines didn’t work.",
            backgroundImage: "/resources/webp/SQINBOX-shot14-1.webp"
          },
          {
            number: "03",
            title: "Treat",
            description: "A personalized treatment is prepared and applied immediately, based on your results.",
            backgroundImage: "/resources/webp/SQINBOX-shot16-2.webp"
          }
        ]}
      />

      <TwoUpGrid
        leftItem={{
          type: 'image',
          image: '/resources/webp/SQINBOX-shot-web1-comp.webp',
          alt: ''
        }}
        rightItem={{
          type: 'content',
          title: "Inspired by the most advanced skincare cultures in the world",
          subtitle: "We don’t follow one skincare system. We extract the best from all of them.",
          description: "From Korea — deep hydration and barrier repair. From Japan — precision and long-term skin balance. From France — dermo-grade sensitivity and skin tolerance. From Switzerland and Germany — bio-engineered actives and cellular performance.",
          bgColor: "#F1F0EF",
          textColor: "#1d1d1f"
        }}
      />

      <TwoUpGrid
        leftItem={{
          type: 'content',
          title: "Access the best skincare in the world — without brand loyalty.",
          subtitle: "SQINBOX selects and combines elite ingredients and treatments from the most advanced global skincare systems, based solely on what your skin needs. No trends. No contracts. No expertise required from you. You get elite results — without knowing anything about skincare.",
          bgColor: "#000",
          textColor: "#fff"
        }}
        rightItem={{
          type: 'image',
          image: '/resources/webp/SQINBOX-shot17-5-comp.webp',
          alt: ''
        }}
      />

      <section style={{
        textAlign: 'center',
        padding: '48px 16px 0px 16px',
        backgroundColor: "#000"
      }}>
        <h1 style={{
          fontSize: '56px',
          fontWeight: 600,
          marginBottom: '16px',
          background: 'linear-gradient(to right, #111, #666)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}>
          The world's first AI-driven immersive skincare pod
        </h1>
        <p style={{
          fontSize: '24px',
          color: '#666',
          marginBottom: '0px'
        }}>
          Watch the video below
        </p>
      </section>

      <VideoBanner />

      <Footer />

    </div>
  );
};

export default App;

async function sendReqWaitingListEmail(userEmail) {
  try {
    const templateParams = {
      to_email: userEmail
    };

    await emailjs.send('service_e67jtac', 'template_hbch8t2', templateParams);
  } catch (error) {
    console.error('Failed to send verification email:', error);
  }
}